import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var CurrencyEthereum = function CurrencyEthereum(props) {
  return /*#__PURE__*/_jsx("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props, {
    children: /*#__PURE__*/_jsx("path", {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      d: "M4 11.0001 12 13l8-2m-16 .0001L12 2m-8 9.0001 8-2M20 11l-8-9m8 9-8-2m0-7v7m-6.5 6 6.5001 7L18.5 15 12 16.5z"
    })
  }));
};
export default CurrencyEthereum;